import { useState } from 'react';

import {
  Button,
  ButtonType,
  Modal,
  ModalWidth,
  TextField,
  TextFieldType,
  Typography,
  TypographyAlignment,
  TypographyFont,
  TypographySize,
  TypographyWeight
} from '~/components/core';
import { nextTrpc } from '~/trpc';

interface UserDisplayNameModalProps {
  onComplete: () => void;
}

const UserDisplayNameModal: React.FC<UserDisplayNameModalProps> = ({
  onComplete
}) => {
  const [name, setName] = useState('');
  const [errorMessage, setErrorMessage] = useState<string>('');

  const updateNameMutation = nextTrpc.users.updateName.useMutation({
    onSuccess: () => {
      onComplete();
    },
    onError: () => {
      setErrorMessage('Failed to set name.');
    }
  });

  const handleChangeName = (value: string) => {
    setName(value);
    if (errorMessage && value.trim()) {
      setErrorMessage('');
    }
  };

  const handleSave = () => {
    const trimmedName = name.trim();

    if (!trimmedName) {
      setErrorMessage('Please enter your name');
      return;
    }

    updateNameMutation.mutate({ name: trimmedName });
  };

  return (
    <Modal open width={ModalWidth.LG}>
      <div className="flex flex-col gap-8 pt-4">
        <Typography
          alignment={TypographyAlignment.CENTER}
          size={TypographySize.H2}
          weight={TypographyWeight.SEMI_BOLD}
        >
          Welcome to Kindo!
        </Typography>

        <div className="flex flex-col gap-3">
          <Typography font={TypographyFont.HEADING} size={TypographySize.LARGE}>
            What's your name?
          </Typography>

          <TextField
            autoFocus
            avoidLayoutShift
            error={!!errorMessage}
            errorMessage={errorMessage}
            onChange={handleChangeName}
            onEnter={handleSave}
            placeholder="John Smith"
            size={TypographySize.LARGE}
            type={TextFieldType.DEFAULT}
            value={name}
          />

          <Button
            fullWidth
            label="Continue"
            loading={updateNameMutation.isLoading}
            onClick={handleSave}
            type={ButtonType.SOLID_GRADIENT}
          />
        </div>
      </div>
    </Modal>
  );
};

export default UserDisplayNameModal;
